interface Unsubscribe {
  (): void;
}

export const observeSelector = <
  TEvent extends keyof HTMLElementEventMap,
  TElement extends HTMLElement
>(
  event: TEvent,
  selector: string,
  callback: (target: TElement, event: HTMLElementEventMap[TEvent]) => void
): Unsubscribe => {
  const handler = (event: HTMLElementEventMap[TEvent]) => {
    let target = event.target;

    while (target !== null && (target instanceof HTMLElement || target instanceof SVGElement)) {
      if (target.matches(selector)) {
        callback(target as TElement, event);
      }

      target = target.parentNode;
    }
  };

  document.addEventListener(event, handler);

  return () => document.removeEventListener(event, handler);
};
